import {readNightVision} from '../hooks/useNightVision.js';
// DOM/chart category colors. The globe keeps its original palette and is tinted
// as a complete media surface by the night-display filter.
export function displayColor(raw){if(readNightVision())return '#f2aaaa';const s=(raw||'#a8b5c6').slice(0,7);return s.toLowerCase()==='#64748b'?'#a8b5c6':s;}
